// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XQ-w","col":"styles_col__3OZ4x","actions":"styles_actions__2ipwk","conflict":"styles_conflict__2bThy"};